<template>
  <section class="solution-header">
    <div class="container">
      <div class="row">
        <div
          class="col-12"
          :class="{
            'col-lg-12': !solution.description || !solution.video,
            'col-lg-6': solution.description || solution.video,
          }"
        >
          <h2 class="h3">{{ solution.title }}</h2>
          <div v-html="solution.description" />
        </div>

        <div
          class="col-12"
          :class="solution.description ? 'col-lg-6' : 'wide-video'"
          v-if="solution.video"
        >
          <YouTubePlayer
            :video-url="solution.video"
            :thumbnail-image="solution.thumbnailImage"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import YouTubePlayer from "@/components/common/YouTubePlayer.vue";

export default {
  components: {
    YouTubePlayer,
  },
  props: {
    solution: {
      type: Object,
      required: true,
    },
  },
};
</script>
